$(() => {
	const storageKey = key => `systemnotification-${key}`;

	$('.callout a.close').click((e) => {
		const $parentCallout = $(e.currentTarget).parents('.callout');
		const notificationId = $parentCallout.data('systemnotification');
		$parentCallout.remove();

		if (notificationId !== undefined) {
			localStorage.setItem(storageKey(notificationId), 'hide');
		}
	});
	$('.callout[data-systemnotification]').each((i, el) => {
		if ($(el).data('calloutdismissable') === false) {
			$(el).show();
			return;
		}
		const notificationId = $(el).data('systemnotification');
		if (notificationId && localStorage.getItem(storageKey(notificationId))) {
			$(el).remove();
		} else {
			$(el).show();
		}
	});
});
